import styled from 'styled-components';

export const Content = styled.main`
  padding: 0px 0px 0px 340px;
  min-height: 600px;

  @media (max-width: 1024px) {
    padding: 2.5rem 0 0 0;
    overflow-x: hidden;
  }
`;

export const DismissButton = styled.button.attrs({
  type: 'button'
})`
  float: left;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
  margin: 0px;
  background: rgba(0,0,0,0);
  padding: 0 20px;
  cursor: pointer;

  @media (max-width: 1024px) {
  }
`;
